export const DEV_ACCESS_TOKEN = 'DevAccessToken';
export const ACCESS_TOKEN = 'AccessToken';

export const DEV_BY_HELP_AUTH = 'DevByHelpAuth';
export const DEV_BY_HELP_EMAIL = 'DevByHelpEmail';

export const BY_HELP_AUTH = 'ByHelpAuth';
export const BY_HELP_EMAIL = 'ByHelpEmail';

export const DEV_MODE = 'dev';
export const PROD_MODE = 'prod';
export const UNKNOWN_MODE = 'unknown';

export const INITIAL_USER_PRINT = {
  activeBranchId: null,
  database: null,
  userId: null,
};

// Результат authenticateByCookie, когда бэкенд недоступен (нет ответа,
// 502/503/504 или заглушка nginx text/html): сессия не проверена, но и не
// отклонена — токен не удаляется, на вход не переводим (issue/11376).
export const AUTH_SERVER_UNAVAILABLE = 'serverUnavailable';
